import React from "react"
import { IDevicePermissions } from "../../models"
import strings from "../../localization/strings"
import { grey500 } from "material-ui/styles/colors"
interface IProps {
    devicePermissions: IDevicePermissions
}

const DevicePermissionsInfo: React.SFC<IProps> = (props: IProps) => {
    return (
        <div style={{ width: 350, fontSize: 16, color: grey500 }}>
            {props.devicePermissions ?
                <div>
                     <div style={{ display: "flex" }}>
                        <div style={{ flex: 5 }}>{strings.Location_permission_granted}:</div>
                        <div style={{ flex: 1 }}>{props.devicePermissions.Location ? strings.Yes : strings.No}</div>
                    </div>
                    {/* IOS is not ready yet, and CCS client confusing for it.
                    so let's hide for now, 
                    we will show it after release new IOS version.
                    <div style={{ display: "flex" }}>
                        <div style={{ flex: 5 }}>{strings.Precise_Location_permission_granted}:</div>
                        <div style={{ flex: 1 }}>{props.devicePermissions.PreciseLocation ? strings.Yes : strings.No}</div>
                    </div> 
                    */}
                    <div style={{ display: "flex" }}>
                        <div style={{ flex: 5 }}>{strings.Camera_permission_granted}:</div>
                        <div style={{ flex: 1 }}>{props.devicePermissions.Camera ? strings.Yes : strings.No}</div>
                    </div>
                    <div style={{ display: "flex" }}>
                        <div style={{ flex: 5 }}>{strings.Storage_permission_granted}:</div>
                        <div style={{ flex: 1 }}>{props.devicePermissions.Storate ? strings.Yes : strings.No}</div>
                    </div>
                    <div style={{ display: "flex" }}>
                        <div style={{ flex: 5 }}>{strings.Phone_call_permissions_granted}:</div>
                        <div style={{ flex: 1 }}>{props.devicePermissions.PhoneCalls ? strings.Yes : strings.No}</div>
                    </div>
                    <div style={{ display: "flex" }}>
                        <div style={{ flex: 5 }}>{strings.NFC_permission_granted}:</div>
                        <div style={{ flex: 1 }}>{props.devicePermissions.NFC ? strings.Yes : strings.No}</div>
                    </div>
                    <div style={{ display: "flex" }}>
                        <div style={{ flex: 5 }}>{strings.Photo_Library_permission_granted}:</div>
                        <div style={{ flex: 1 }}>{props.devicePermissions.PhotoLibrary ? strings.Yes : strings.No}</div>
                    </div>
                </div> :
                <div>
                    {strings.This_device_not_uploaded_permission_data}
                </div>
            }
        </div>
    )
}

export default DevicePermissionsInfo
